import { gql, type TypedDocumentNode } from '@apollo/client';
import type {
  MyCpmCampaignAutomaticImportQuery, MyCpmCampaignAutomaticImportQueryVariables,
  SetMyCpmCampaignAutomaticImportMutation, SetMyCpmCampaignAutomaticImportMutationVariables,
} from '@/generated/campaign-social-import';

export const MY_CPM_CAMPAIGN_AUTOMATIC_IMPORT = gql`
  query MyCpmCampaignAutomaticImport($campaignId: ID!) {
    myCpmCampaignAutomaticImport(campaignId: $campaignId)
  }
` as TypedDocumentNode<MyCpmCampaignAutomaticImportQuery, MyCpmCampaignAutomaticImportQueryVariables>;

export const SET_MY_CPM_CAMPAIGN_AUTOMATIC_IMPORT = gql`
  mutation SetMyCpmCampaignAutomaticImport($campaignId: ID!, $enabled: Boolean!) {
    setMyCpmCampaignAutomaticImport(campaignId: $campaignId, enabled: $enabled)
  }
` as TypedDocumentNode<SetMyCpmCampaignAutomaticImportMutation, SetMyCpmCampaignAutomaticImportMutationVariables>;
